import { api } from '@here/api'
import { useLocation, useNavigate } from '@solidjs/router'
import { setUser } from '@state'
import { type ParentProps, Show, createSignal, onMount } from 'solid-js'

export const RouteGuard = (props: ParentProps) => {
	const navigate = useNavigate()
	const location = useLocation()
	const [loading, setLoading] = createSignal(true)

	onMount(async () => {
		try {
			// setLoading(false)
			const { data, error } = await api().auth.getSession()

			if (error?.code === 'refresh_token_not_found') {
				await api().auth.signOut({ scope: 'local' })
				navigate('/login', {
					replace: true,
					state: { loginRedirect: location.pathname },
				})
				return
			}

			if (data.session) {
				console.log('🔒 RouteGuard: User session found and set')
				setUser(data.session)
			} else {
				navigate('/login', {
					replace: true,
					state: { loginRedirect: location.pathname },
				})
			}
		} catch (e) {
			// On error, treat as no session and redirect
			navigate('/login', {
				replace: true,
				state: { loginRedirect: location.pathname },
			})
		} finally {
			console.log('🔒 RouteGuard: Session check complete')
			setLoading(false)
		}
	})

	api().auth.onAuthStateChange((event, session) => {
		if (event === 'SIGNED_OUT') {
			// user signed out: redirect to login
			navigate('/login', {
				replace: true,
				state: { loginRedirect: location.pathname },
			})
		}
	})

	return (
		<div>
			<Show
				when={!loading()}
				fallback={<p>loading</p>}
			>
				{props.children}
			</Show>
		</div>
	)
}
